import script from "./WritingFreeView.vue?vue&type=script&setup=true&lang=js"
export * from "./WritingFreeView.vue?vue&type=script&setup=true&lang=js"

import "./WritingFreeView.vue?vue&type=style&index=0&id=513782e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-513782e2"]])

export default __exports__